export default __webpack_public_path__ + "static/media/filter.cfe2312a.svg";